import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import parse from 'html-react-parser';

import {Dialog} from 'primereact/dialog';
import {Splitter, SplitterPanel} from 'primereact/splitter';

import {StoreState} from '~/frontend/src/store';
import clearPanelPropsValidationError from '~/frontend/src/actions/panelManager/clearPanelPropsValidationError';

const PanelPropsValidationErrorDialog = () => {
    const dispatch                  = useDispatch(),
          panelPropsValidationError = useSelector( ( state : StoreState ) => state.panelManager?.panelPropsValidationError );

    if ( panelPropsValidationError.title ) {
        return <Dialog
            header={parse( panelPropsValidationError.title )}
            visible={true}
            onHide={() => dispatch( clearPanelPropsValidationError() )}
            closable={true}
            className="yn-error-dialog yn-flex-layout-parent"
            contentClassName="yn-flex-layout-parent"
            maskClassName="yn-dialog-panel-modal"
            style={{ width: '40%', maxWidth: '80%', height: '90%' }}
        >
            <Splitter
                className="yn-flex-layout-child"
                style={{ zIndex: 4 }}
            >
                <SplitterPanel
                    size={50}
                    className="yn-flex-layout-parent"
                >
                        <textarea
                            className="yn-flex-layout-child yn-code-textarea"
                            value={JSON.stringify( panelPropsValidationError.panelProps, null, 4 )}
                            onChange={() => {
                            }}
                        />
                </SplitterPanel>
                <SplitterPanel
                    size={50}
                    className="yn-flex-layout-parent"
                >
                    <div
                        className="yn-flex-layout-child yn-border"
                        style={{ padding: '1rem 0.75rem' }}
                    >
                        {parse( panelPropsValidationError.text )}
                        {panelPropsValidationError.details.length
                            ? <>
                                <br/><br/>Error details:<br/>
                                <ul className="yn-error-details">
                                    {panelPropsValidationError.details.map( ( detail, index ) => {
                                        const detailKey  = detail.replace( /^"([^"]+)"(.*)$/, '$1' ),
                                              detailText = detail.replace( /^"([^"]+)"(.*)$/, '$2' );
                                        return <li key={`errorDetail_${index}`}><strong>{detailKey}</strong>{detailText}</li>;
                                    } )}
                                </ul>
                            </>
                            : ''
                        }
                    </div>
                </SplitterPanel>
            </Splitter>
        </Dialog>;
    }
    else {
        return <></>;
    }
}

export default PanelPropsValidationErrorDialog;
